module.exports = "<div class=\"Description-box\">\r\n  <i class=\"fa fa-desktop kt-font-brand\" ></i>\r\n  <h4>{{description}}</h4>\r\n</div>"